<template lang="pug">
#modal-confirmar-aprovar-reprovar-operacao-cda-wa
    el-dialog(
        :title='aprovar ? "Confirmar aprovação da operação" : "Confirmar reprovação da operação"',
        width='610px',
        :visible='show',
        @close='closeDialog()'
    )
        h4.mb-4 {{`Atenção. Após ${aprovar ? "aprovação" : "reprovação"}, a operação não poderá ser editada. Deseja continuar?`}}
        p
            b Identificador da operação CDA-WA:
            |
            | {{ identificador }}

        .buttons.d-flex.justify-content-between
            BaseButton(size='mini', @click='closeDialog()')
                | Fechar
            BaseButton(
                type='primary',
                size='mini',
                @click='$emit("acao")'
            ) Confirmar
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalConfirmarAprovarReprovarOperacaoCdaWa',
    components: {
        BaseButton
    },
    emits: ['acao', 'fechar'],
    props: {
        aprovar: {
            type: Boolean,
            required: true
        },
        identificador: {
            type: String | undefined,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        closeDialog() {
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss">
#modal-confirmar-aprovar-reprovar-operacao-cda-wa {
    border-radius: 5px;

    .center-align {
        text-align: center;
    }

    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }
}
</style>
